<template>
  <div class="page" :style="{'padding-top': safeArea.top + 'px'}">
    <!-- <div class="page-nav">
      <slot name="nav">
      </slot>
    </div> -->
    <div class="page-head" :style="{'background': bgcolor}">
      <slot name="head">
        <!-- <div v-if="back" class="back"></div> -->
        <img v-if="back" class="back" src="../../assets/imgs/back.png" alt="" @click="onBack">
        <img class="logo" src="../../assets/imgs/logo.jpg" alt="" />
        <div v-if="righticon" class="righticon">
          <!-- <span @click="showLangSelect">{{ locale.label }}</span> -->
        </div>
      </slot>
    </div>
    <div class="page-body">
      <slot></slot>
    </div>
    <div class="page-foot" v-if="hasFoot">
      <slot name="foot"></slot>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    showBack: {
      type: Boolean,
      default: true
    },
    back: {
      type: Boolean,
      default: false
    },
    logo: {
      type: Boolean,
      default: true
    },
    righticon: {
      type: Boolean,
      default: false
    },
    bgcolor: {
      type: String,
      default: 'transparent'
    }
  },
  computed: {
    ...mapState(['safeArea']),
    ...mapGetters(['locale']),
    hasHead () {
      return this.$slots.head || this.title
    },
    hasFoot () {
      return this.$slots.foot
    }
  },
  methods: {
    showLangSelect () {
      this.$store.commit('isLangView', true)
    },
    goRouter (path) {
      this.$router.push(path)
    },
    onBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less">
.page{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100vh;
  &-head{
    font-size: 36px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin: 20px 0 0;
    padding: 20px;
    // height: 100px;
    overflow: hidden;
    .menu {
      width: 60px;
      margin-right: 32px;
    }
    .back {
      width: 8%;
      margin-left: 15px;
    }
    .logo{
      width: 15%;
      border-radius: 20px;
    }
    .righticon{
      width: 10%;
    }
  }
  // &-head+&-body{
  //   padding-top: 88px;
  // }
  &-body{
    height: 100%;
    // max-height: 87%;
  }
  &-foot{
    background: #FFFFFF;
    position: fixed;
    bottom: 0;
    width: 100%;
  }
}
.page-head-default .home {
  height: 40px;
  width: 40px;
  // position: absolute;
  left: calc(100vw - 72px);
  right: 32px;
  transform: scale(1.4);
  position: fixed;
}
</style>
